import { render } from "./LoginForm.vue?vue&type=template&id=031a49f8&scoped=true&ts=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=031a49f8&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031a49f8"]])

export default __exports__